export const EXTRA_COLSPANS = {
  'wysiwyg.viewer.components.inputs.TextAreaInput': 2,
  'wysiwyg.viewer.components.inputs.RadioGroup': 1,
  'wysiwyg.viewer.components.inputs.CheckboxGroup': 1,
}
